import PropTypes from "prop-types";
import ProductDeal from "./ProductDeal";
import ProductSponsored from "./ProductSponsored";
import SellingFastBadge from "./SellingFastBadge";
import styles from "./index.css";
import classnames from "classnames";
import ProductBadge from "./ProductBadge";
import {
  MIX_MATCH,
  MORE_COLOURS,
  MORE_COLOURS_FACET
} from "../../state/modules/search/constants";

const Banners = ({
  deal,
  dealAria,
  isSponsored,
  isSellingFast,
  sellingFastStyle,
  ariaLabels,
  badgeType
}) => (
  <>
    {deal !== null && (
      <ProductDeal
        deal={deal}
        dealAria={dealAria}
        className={styles.topLeftBadge}
        labelledById={ariaLabels.deal}
      />
    )}
    {isSponsored && (
      <ProductSponsored
        className={styles.topRightBadge}
        labelledById={ariaLabels.sponsored}
      />
    )}
    {isSellingFast && (
      <SellingFastBadge
        className={classnames(styles.sellingFastBadge, sellingFastStyle)}
        labelledById={ariaLabels.sellingFast}
      />
    )}
    {badgeType && (
      <ProductBadge
        className={styles.bottomLeftBadge}
        type={badgeType}
        labelledById={ariaLabels.productBadge}
      />
    )}
  </>
);

Banners.propTypes = {
  deal: PropTypes.string,
  dealAria: PropTypes.string,
  isSponsored: PropTypes.bool.isRequired,
  isSellingFast: PropTypes.bool.isRequired,
  sellingFastStyle: PropTypes.string,
  ariaLabels: PropTypes.shape({
    deal: PropTypes.string,
    sponsored: PropTypes.string,
    sellingFast: PropTypes.string,
    productBadge: PropTypes.string
  }),
  badgeType: PropTypes.oneOf([MIX_MATCH, MORE_COLOURS, MORE_COLOURS_FACET])
};

export default require("../../containers/withTogglePoint").default(Banners, require.context("./__variants__/", true, /^\.\/([^/]+\/){2}index\.js$/))
